import React from 'react';
import { NoDataTab } from 'javascripts/analytics/components/NoDataTab';
import { CountriesPanel } from 'javascripts/analytics/components/countries_panel';

export class CountriesTabContainer extends React.Component {
  getStateFromStore = () => {
    return {
      countries: Aedu.ReduxStore.getState().AnalyticsDashboard.Countries,
      displayedDates:
        Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates,
    };
  };

  state = this.getStateFromStore();

  componentDidMount() {
    this.unsubscribe = Aedu.ReduxStore.subscribe(
      function () {
        this.setState(this.getStateFromStore());
      }.bind(this),
    );

    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.Countries.fetch(),
    );
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    if (this.state.countries.models.length) {
      return (
        <CountriesPanel
          countries={this.state.countries.models}
          countAttribute="thirtyDayViews"
          dayCount={this.state.displayedDates.dayCount}
        />
      );
    } else if (
      this.state.countries.meta.fetching &&
      this.state.countries.models.length === 0
    ) {
      return (
        <div className="u-taCenter u-pv4x">
          <i className="fa fa-spin fa-spinner u-fs36"></i>
        </div>
      );
    } else {
      return (
        <NoDataTab
          title="You haven't added any papers yet."
          details="This page shows geographic data about your visitors.<br> To get more visitors, make sure you've uploaded and tagged all your papers."
          loggedOutTitle={
            Aedu.User.viewed.display_name + " hasn't had any visitors yet."
          }
        />
      );
    }
  }
}
